<script>
export default {
    props: {
        online: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<template>
    <span v-if="online" class="badge badge-soft-success font-size-11">
        <i class="ri-global-line mr-1"></i>
        Online
    </span>
    <span v-else class="badge badge-soft-info font-size-11">
        <i class="ri-store-line mr-1"></i>
        Física
    </span>
</template> 